import $ from "jquery";

export default class StandoutList {
  $el = $("section.standout-list");

  constructor() {
    if (!this.$el.length) return;

    this.init();
  }

  init() {
    this.setImagePosition();

    window.onresize = () => {
      this.setImagePosition();
    };
  }

  setImagePosition() {
    let line = this.$el.find(".break");
    let image = this.$el.find("img");

    if (window.innerWidth < 768) {
      image.css("bottom", "0px");
      return;
    }

    if (line.length && image.length) {
      image.css("bottom", -line.height() + 60 + "px");
    }
  }
}
